import { Controller, useFormContext } from "react-hook-form";
import { CheckboxGroup, CheckboxGroupProps } from "./checkbox-group";

export type ControlledCheckboxGroupProps<T extends string | number> = Omit<
  CheckboxGroupProps<T>,
  "onValueChange" | "errorMessage"
> & {
  name: string;
};

export function ControlledCheckboxGroup<T extends string | number>(
  props: ControlledCheckboxGroupProps<T>,
) {
  const { control } = useFormContext();
  return (
    <Controller
      control={control}
      name={props.name}
      render={({ field, fieldState }) => (
        <CheckboxGroup<T>
          {...field}
          onValueChange={field.onChange}
          {...props}
          errorMessage={fieldState?.error?.message}
          isInvalid={!!fieldState?.error?.message}
        />
      )}
    />
  );
}

ControlledCheckboxGroup.displayName = "RecareUI.ControlledCheckboxGroup";
